// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import AlrSchema from './alr-schema';

const schema = {
  $id: '/customerdata-schema',
  type: 'object',
  required: ['name'],
  properties: {
    alr: {
      ...AlrSchema,
    },
    doms: {
      type: 'array',
      nullable: true,
      items: {
      },
    },
    loc: {
      nullable: true,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    tags: {
      type: 'array',
      nullable: true,
      items: {
      },
    },
  },
} as IJSONSchema;

export default schema;
